import { Flex,Table } from 'antd'
import React, { useEffect, useState } from 'react'
import classes from './cost.module.css' 
import ReportStateTag from '../../cpn/StateTag';
import CostAddReportEdit from './CostAddReportEdit';    
import CostEditReportEdit from './CostEditReportEdit';
import Copy from '../../cpn/Copy';
import CostCheck from './CostCheck';
function CostListReport(props) {

     // 格式化金额显示
     const formatCurrency = (text) => (
         <span style={{color:'green'}}>
             ￥{Number(text).toLocaleString('zh-CN', {
                 minimumFractionDigits: 2,
                 maximumFractionDigits: 2
             })}
         </span>
     );
     const [list, setList] = useState([])
    useEffect(() => {
        if(props.zc_data){
            setList([...props.zc_data].sort((a, b) => a.ddzc_id - b.ddzc_id))
        }
    }, [props.zc_data])
     // 基础列定义
     const columns = [
        {  
            dataIndex: 'index', 
            width: 42, 
            key: 'index' ,
            render: (text, record, index) => index + 1,
            title: '序号',
        },
        { 
            title: '付款客户', 
            dataIndex: 'ddzc_kh_name', 
            width: 200, 
            key: 'ddzc_kh_name',
            render: (text, record) => {
                if(record.ddzc_state === '1'){
                    return <CostEditReportEdit
                                ddzc_id={record.ddzc_id}
                                yh_id={props.yh_id}
                                yh_name={props.yh_name}
                                ddzc_bzd_id={record.ddzc_bzd_id}
                                ddzc_price={record.ddzc_price}
                                ddzc_content={record.ddzc_content}
                                ddzc_date={record.ddzc_date}
                                ddzc_bzd_date={props.dsbzd_date}
                                ddzc_bzd_date_end={props.dsbzd_date_end}
                                ddzc_bzd_name={props.dsbzd_name}
                                ddzc_type_id={record.ddzc_type_id}
                                ddzc_type_name={record.ddzc_type_name}
                                ddzc_kh_id={record.ddzc_kh_id}
                                ddzc_kh_name={record.ddzc_kh_name}
                                qy_id={props.qy_id}
                                qy_name={props.qy_name}
                                ddzc_num={record.ddzc_num}
                                ddzc_amount={record.ddzc_amount}
                                ddzc_uid={record.ddzc_uid}
                                ddzc_state={record.ddzc_state}
                                ddzc_state_time={record.ddzc_state_time}
                                ddzc_uname={record.ddzc_uname}
                                ddzc_image_name={record.ddzc_image_name}
                                ddzc_image_file={record.ddzc_image_file}
                                ddzc_name={record.ddzc_name}
                                ddzc_bm_id={record.ddzc_bm_id}
                                ddzc_bm_name={record.ddzc_bm_name}
                                ddzc_khyhzh_id={record.ddzc_khyhzh_id}
                                ddzc_khyhzh_name={record.ddzc_khyhzh_name}
                                ddzc_ctime={record.ddzc_ctime}
                            />
                }else{
                    return <CostCheck
                                type='button'
                                ddzc_id={record.ddzc_id}
                                yh_id={props.yh_id}
                                yh_name={props.yh_name}
                                ddzc_bzd_id={record.ddzc_bzd_id}
                                ddzc_price={record.ddzc_price}
                                ddzc_content={record.ddzc_content}
                                ddzc_date={record.ddzc_date}
                                dsbzd_date={props.dsbzd_date}
                                dsbzd_date_end={props.dsbzd_date_end}
                                dsbzd_name={props.dsbzd_name}
                                ddzc_type_id={record.ddzc_type_id}
                                ddzc_type_name={record.ddzc_type_name}
                                ddzc_kh_id={record.ddzc_kh_id}
                                ddzc_kh_name={record.ddzc_kh_name}
                                qy_id={props.qy_id}
                                qy_name={props.qy_name}
                                ddzc_num={record.ddzc_num}
                                ddzc_amount={record.ddzc_amount}
                                ddzc_uid={record.ddzc_uid}
                                ddzc_state={record.ddzc_state}
                                ddzc_image_name={record.ddzc_image_name}
                                ddzc_image_file={record.ddzc_image_file}
                                dsbzd_id={props.dsbzd_id}
                                ddzc_name={record.ddzc_name}
                                ddzc_bm_id={record.ddzc_bm_id}
                                ddzc_bm_name={record.ddzc_bm_name}
                                ddzc_khyhzh_id={record.ddzc_khyhzh_id}
                                ddzc_khyhzh_name={record.ddzc_khyhzh_name}
                                ddzc_ctime={record.ddzc_ctime}
                            />
                }
            }
        },
        { 
             title: '付款金额', 
             dataIndex: 'ddzc_amount',    
             width: 200, 
             key: 'ddzc_amount', 
             render: formatCurrency 
         },
        { 
            title: '备注', 
            dataIndex: 'ddzc_content', 
            key: 'ddzc_content',
            render: (text) => <Copy title={text}/>
        },    
        {
            title: '状态',
            dataIndex: 'ddzc_state',
            key: 'ddzc_state',
            render: (text) => <ReportStateTag state={text} />,
            width: 80,
        },
        {
            title: '编号',
            width: 60, 
            key:'ddzc_id',
            dataIndex:'ddzc_id',            
        },
       
     ];

    return (
        <div>
            <Flex align='center' justify='space-between' style={{marginTop:'10px'}}>
                <div style={{fontSize:'16px',fontWeight:'bold',color:'green'}}>付款单</div>                
                {props.report_type === 'edit' ? <CostAddReportEdit  
                    yh_id={props.yh_id}
                    yh_name={props.yh_name}
                    dsbzd_id={props.dsbzd_id}                                                                           
                    dsbzd_date={props.dsbzd_date}
                    dsbzd_date_end={props.dsbzd_date_end}
                    dsbzd_name={props.dsbzd_name}
                    qy_id={props.qy_id}
                    qy_name={props.qy_name}
                    dsbzd_uid={props.dsbzd_uid}
                    dsbzd_state={props.dsbzd_state}
                    dsbzd_bm_id={props.dsbzd_bm_id}
                    dsbzd_bm_name={props.dsbzd_bm_name}
                    dsbzd_dscp_id={props.dsbzd_dscp_id}
                    dsbzd_dscp_name={props.dsbzd_dscp_name}
                    dsbzd_kh_id={props.dsbzd_kh_id}
                    dsbzd_kh_name={props.dsbzd_kh_name}
                /> : null}                    
            </Flex>
            <Table 
                className={classes.greenHeader}
                dataSource={list}
                columns={columns}
                pagination={false}
                style={{marginTop:'10px'}}
                size='small'
                rowKey="ddzc_id"                    
                summary={pageData => {
                    const total = pageData.reduce((sum, row) => sum + Number(row.ddzc_amount || 0), 0);    
                    if(total>0){
                        return (
                            <Table.Summary.Row>
                                <Table.Summary.Cell index={0} key="summary-0" colSpan={1}></Table.Summary.Cell>
                                <Table.Summary.Cell index={1} key="summary-1" colSpan={1}></Table.Summary.Cell> 
                                <Table.Summary.Cell index={2} key="summary-2" colSpan={1}>
                                    <span style={{color:'green'}}>合计￥{Number(total).toLocaleString('zh-CN', {
                                                                    minimumFractionDigits: 2,
                                                                    maximumFractionDigits: 2
                                                                })}</span>
                                </Table.Summary.Cell>
                                <Table.Summary.Cell index={3} key="summary-3" colSpan={columns.length - 2} ></Table.Summary.Cell>
                            </Table.Summary.Row>
                        );
                    }
                    return null;
                }}
                locale={{
                    emptyText: '暂无付款单' // This will display text when the table is empty
                }}
            />
        </div>
    )
}

export default CostListReport